import bancontact from "@Images/logo-bancontact.png";
import mastercard from "@Images/logo-mastercard.png";
import paypal from "@Images/logo-paypal.png";
import sofort from "@Images/logo-sofort.png";
import visa from "@Images/logo-visa.png";
import mastercardLogo from "@Images/mastercard.png";
import paypalLogo from "@Images/paypal.png";
import visaLogo from "@Images/visa.png";
import { PaymentMethod } from "@Types/cart";

export const generic = "cheerz_CheckoutPaymentStep_error_generic";
const applePay = "cheerz_CheckoutPaymentStep_error_applePay";
const bank = "cheerz_CheckoutPaymentStep_error_bank";
const cardAddressInvalid = "cheerz_CheckoutPaymentStep_error_cc_address_invalid";
const cardAuthorization = "cheerz_CheckoutPaymentStep_error_cc_authorization";
const cardMonthInvalid = "cheerz_CheckoutPaymentStep_error_cc_month_invalid";
const cardNameInvalid = "cheerz_CheckoutPaymentStep_error_cc_name_invalid";
const cardYearInvalid = "cheerz_CheckoutPaymentStep_error_cc_year_invalid";
const cardLimits = "cheerz_CheckoutPaymentStep_error_cc_limits";
const failed = "cheerz_CheckoutPaymentStep_error_failed";
const invalidEmail = "cheerz_CheckoutPaymentStep_error_email_invalid";
const missingInformation = "cheerz_CheckoutPaymentStep_error_missingInformation";
const rejected = "cheerz_CheckoutPaymentStep_error_rejected";
const suspendedContactBank = "cheerz_CheckoutPaymentStep_error_suspendedContactBank";
const suspendedContactUs = "cheerz_CheckoutPaymentStep_error_suspendedContactUs";

interface ErrorMessages {
  [key: string]: string;
}

export const errorMessages: ErrorMessages = {
  "applepay.no-success-handler": applePay,
  "applepay.not-available": applePay,
  "applepay.not-supported": applePay,
  "card.acquirer-failed": suspendedContactBank,
  "card.bad-track-data": "cheerz_CheckoutPaymentStep_error_cc_data_invalid",
  "card.blacklisted": cardAuthorization,
  "card.contact-bank": bank,
  "card.currency-unsupported": "cheerz_CheckoutPaymentStep_error_currency",
  "card.declined": bank,
  "card.do-not-honor": bank,
  "card.dont-retry": "cheerz_CheckoutPaymentStep_error_dontRetry",
  "card.duplicate": "cheerz_CheckoutPaymentStep_error_duplicate",
  "card.exceeded-activity-limits": cardLimits,
  "card.exceeded-limits": cardLimits,
  "card.exceeded-withdrawal-limit": "cheerz_CheckoutPaymentStep_error_withdrawalLimit",
  "card.expired": "cheerz_CheckoutPaymentStep_error_cc_expired",
  "card.expired-3ds": failed,
  "card.failed-3ds": failed,
  "card.failed-avs": failed,
  "card.failed-avs-address": failed,
  "card.failed-avs-postal": failed,
  "card.failed-cvc": failed,
  "card.failed-cvc-and-avs": failed,
  "card.invalid": "cheerz_CheckoutPaymentStep_error_cc_invalid",
  "card.invalid-account": cardAuthorization,
  "card.invalid-address": cardAddressInvalid,
  "card.invalid-cvc": "cheerz_CheckoutPaymentStep_error_cc_CVC_invalid",
  "card.invalid-expiry-date": "cheerz_CheckoutPaymentStep_error_cc_date_invalid",
  "card.invalid-expiry-month": cardMonthInvalid,
  "card.invalid-expiry-year": cardYearInvalid,
  "card.invalid-month": cardMonthInvalid,
  "card.invalid-name": cardNameInvalid,
  "card.invalid-number": "cheerz_CheckoutPaymentStep_error_cc_number_invalid",
  "card.invalid-pin": "cheerz_CheckoutPaymentStep_error_cc_code_invalid",
  "card.invalid-year": cardYearInvalid,
  "card.invalid-zip": "cheerz_CheckoutPaymentStep_error_cc_zipcode_invalid",
  "card.issuer-down": bank,
  "card.issuer-failed": suspendedContactBank,
  "card.issuer-not-found": "cheerz_CheckoutPaymentStep_error_declined",
  "card.lost": cardAuthorization,
  "card.maximum-attempts": "cheerz_CheckoutPaymentStep_error_maxAttempts",
  "card.missing-3ds": failed,
  "card.missing-cvc": "cheerz_CheckoutPaymentStep_error_cc_CVC_missing",
  "card.missing-expiry": "cheerz_CheckoutPaymentStep_error_cc_date_missing",
  "card.missing-number": "cheerz_CheckoutPaymentStep_error_cc_number_missing",
  "card.needs-authentication": "cheerz_CheckoutPaymentStep_error_3DS",
  "card.network-failed": bank,
  "card.no-action-taken": "cheerz_CheckoutPaymentStep_error_provider",
  "card.no-money": "cheerz_CheckoutPaymentStep_error_moreFunds",
  "card.not-activated": "cheerz_CheckoutPaymentStep_error_cc_activation",
  "card.not-authorized": cardAuthorization,
  "card.not-registered": cardAuthorization,
  "card.not-supported": bank,
  "card.please-retry": "cheerz_CheckoutPaymentStep_error_basic",
  "card.possible-fraud": bank,
  "card.processing-error": bank,
  "card.revoked": cardAuthorization,
  "card.revoked-all": cardAuthorization,
  "card.security-violation": suspendedContactBank,
  "card.stolen": cardAuthorization,
  "card.test": cardAuthorization,
  "card.type-not-supported": bank,
  "card.unsupported-3ds": failed,
  "customer.canceled": "cheerz_CheckoutPaymentStep_error_cancel",
  "customer.popup-blocked": "cheerz_CheckoutPaymentStep_error_popups",
  "gateway.declined": rejected,
  "gateway.invalid-response": rejected,
  "gateway.not-allowed": generic,
  "gateway.possible-fraud": bank,
  "gateway.unknown-error": suspendedContactBank,
  "gateway.validation-error": generic,
  "payment.declined": bank,
  "payment.pending": "cheerz_CheckoutPaymentStep_error_pending",
  "processout-js.customer-action-not-supported": suspendedContactUs,
  "processout-js.field.unavailable": "cheerz_CheckoutPaymentStep_error_cc_field",
  "processout-js.invalid-config": suspendedContactUs,
  "processout-js.invalid-field": suspendedContactUs,
  "processout-js.invalid-field-type": suspendedContactUs,
  "processout-js.invalid-type": suspendedContactUs,
  "processout-js.missing-invoice-id": missingInformation,
  "processout-js.missing-project-id": suspendedContactUs,
  "processout-js.missing-resource-id": missingInformation,
  "processout-js.missing-source": suspendedContactUs,
  "processout-js.modal.unavailable": suspendedContactBank,
  "processout-js.network-issue": "cheerz_CheckoutPaymentStep_error_network",
  "processout-js.no-customer-action": suspendedContactUs,
  "processout-js.not-hosted": suspendedContactBank,
  "processout-js.undefined-field": suspendedContactUs,
  "processout-js.wrong-type-for-action": suspendedContactUs,
  "request.gateway.not-available": suspendedContactBank,
  "request.gateway.not-supported": suspendedContactUs,
  "request.validation.error": "cheerz_CheckoutPaymentStep_error_information",
  "request.validation.invalid-address": cardAddressInvalid,
  "request.validation.invalid-country": "cheerz_CheckoutPaymentStep_error_country",
  "request.validation.invalid-email": invalidEmail,
  "request.validation.invalid-name": cardNameInvalid,
  "request.validation.missing-email": invalidEmail,
  "request.validation.missing-name": "cheerz_CheckoutPaymentStep_error_cc_name_missing",
  "request.validation.no-method-selected": "cheerz_CheckoutPaymentStep_error_paymentMethod",
  "resource.invalid-type": missingInformation,
  "three-d-s-2.fingerprint-timed-out": "cheerz_CheckoutPaymentStep_error_3DS_timeout",
};

export const getInputError = (code: string): string | undefined => {
  const cvcInputErrors = [
    "card.failed-cvc",
    "card.failed-cvc-and-avs",
    "card.invalid-cvc",
    "card.missing-cvc",
  ];
  const dateInputErrors = [
    "card.expired",
    "card.expired-3ds",
    "card.invalid-expiry-date",
    "card.invalid-expiry-month",
    "card.invalid-expiry-year",
    "card.invalid-month",
    "card.invalid-year",
    "card.missing-expiry",
  ];
  const nameInputErrors = [
    "card.invalid-name",
    "request.validation.invalid-name",
    "request.validation.missing-name",
  ];
  const numberInputErrors = ["card.invalid-number", "card.missing-number"];

  if (new Set(cvcInputErrors).has(code)) {
    return "cvc";
  } else if (new Set(dateInputErrors).has(code)) {
    return "date";
  } else if (new Set(nameInputErrors).has(code)) {
    return "name";
  } else if (new Set(numberInputErrors).has(code)) {
    return "number";
  } else {
    return undefined;
  }
};

export const getPaymentMethodLogos = (method: PaymentMethod): string[] => {
  switch (method) {
    case "bancontact":
      return [bancontact];
    case "cc":
      return [visa, mastercard];
    case "paypal":
      return [paypal];
    case "sofort":
      return [sofort];
    default:
      return [];
  }
};

export const paymentTypes = [
  { name: "Mastercard", src: mastercardLogo },
  { name: "Visa", src: visaLogo },
  { name: "Paypal", src: paypalLogo },
];
